
import { Component, Prop, Vue } from "vue-property-decorator";
import { pxToVw } from '@/utils/pxToVw'
import Bridge from "@/utils/bridge";
import { Action, Getter } from "vuex-class";
import { backHomes, backToBefore } from "@/utils/h5ToApp";
@Component
export default class BackNavStore extends Vue {
  @Prop({ default: true }) showBack!: boolean;
  @Prop({ default: true }) showBackHome!: boolean;
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "#333" }) color?: string; // 字体图标颜色
  @Prop({ default: () => {} }) readonly handleBack?: () => void; // 返回
  @Prop({ default: () => {} }) readonly handleHomeBack?: () => void; // 返回首页
  @Action setOrderFromPage!: (val: string) => void;
  @Prop({ default: "#ffffff" }) bgColor?: string; // 背景颜色
  @Getter topSafetyHeight!: number
  get topSafetyHeightCss(): string {
    return pxToVw(this.topSafetyHeight)
  }
  goBack() {
    if (this.handleBack) {
      this.handleBack();
    } else {
      this.$router.back();
    }
  }

  /**
   * 直接跳转回首页
   */
  goHome() {
    if (this.$store.state.order.orderFromPage === "1") {
      this.setOrderFromPage("0");
      backToBefore();
      return false;
    }
    if (this.handleHomeBack) {
      this.handleHomeBack();
    } else {
      this.$goHomeBack();
    }
  }
}
